<template>
<v-dialog
    v-model="dialog"
    fullscreen
>
    <v-card>
        <v-toolbar
            dark
            color="primary"
        >
            <v-toolbar-title>Select {{crm_name}} Customer</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn
                    dark
                    text
                    @click="onClickDiscardChanges"
                >
                    Cancel
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>

        <v-card-text
            style="margin-top: 15px;"
        >
           <h1 style="margin-bottom: 15px;">Select {{crm_name}} Customer</h1>

           <v-card
            style="margin-bottom: 15px;"
            v-for="(customer, index) in customers"
            :key="index"
           >
            <v-card-title>{{customer.full_name}}</v-card-title>
            <v-card-text>
                {{customer.city}} {{customer.state}} {{customer.zip}} {{customer.country}}

                <div
                    v-for="(email, index) in customer.customer_emails"
                    :key="index"
                >
                    {{email}}
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                
                <v-btn
                    color="primary"
                    @click="onClickOpen(customer)"
                >
                Open
                </v-btn>
            
            </v-card-actions>

           </v-card>

        </v-card-text>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,
            customers: [],
            crm_name: null,
        }
    },

    methods: {

        showDialog(crm_name, customers)
        {
            this.crm_name = crm_name;
            this.customers = customers;
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }
        
            this.dialog = false;
            next(false); 
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onClickOpen(customer)
        {
            this.closeDialog();

            window.open(customer.url_view_customer_in_crm, '_blank');
        }

    },
}
</script>

<style lang="scss" scoped>
</style>